import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OrderService } from "../../services/order/order.service";
import { OrderItemAttributes } from "@models/orderItem.model";
import { OrderAttributes, OrderItemFilterStatus, OrderStatus } from "@models/order.model";
import { Location } from "@angular/common";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

@Component({
    selector: "app-item-list",
    templateUrl: "./item-list.component.html",
    styleUrl: "./item-list.component.scss",
    standalone: false,
})
export class ItemListComponent implements OnInit {
    private orderId!: string;
    public type!: string;
    public orderItems: OrderItemAttributes[] = [];
    public selectedItems: Set<number> = new Set<number>();
    public orderStatus = OrderStatus;
    public buttonLabel: string = "";
    public heading: string = "";
    public filterStatus: string = "";
    public isLoading: boolean = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private orderService: OrderService,
        private location: Location,
        private translate: TranslateService,
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.orderId = params["id"];
            this.type = params["action"];
        });

        if (this.type) {
            const buttonKey =
                this.type === "return"
                    ? "orderItemList.button.return"
                    : this.type === "exchange"
                    ? "orderItemList.button.exchange"
                    : "orderItemList.button.cancel";

            this.getTranslationAsync(buttonKey).subscribe((translated: string) => {
                this.buttonLabel = translated;
            });

            const headingKey =
                this.type === "return"
                    ? "orderItemList.heading.return"
                    : this.type === "exchange"
                    ? "orderItemList.heading.exchange"
                    : "orderItemList.heading.cancel";

            this.getTranslationAsync(headingKey).subscribe((translated: string) => {
                this.heading = translated;
            });
            this.filterStatus =
                this.type === "return"
                    ? OrderItemFilterStatus.Returnable
                    : this.type === "exchange"
                    ? OrderItemFilterStatus.Exchangeable
                    : OrderItemFilterStatus.Cancellable;
        }

        if (this.orderId) {
            this.getOrderItemsByStatus();
        }
    }

    private getOrderItemsByStatus(): void {
        this.isLoading = true;
        this.orderService.getOrderItemsByStatus(this.orderId, this.filterStatus).subscribe((response) => {
            this.orderItems = response;
            this.isLoading = false;
        });
    }

    public goBack(): void {
        this.location.back();
    }

    public navigateReturnReplacePage(): void {
        const selectedItemIds = this.selectedItems;

        this.router.navigate([`account/orders/${this.orderId}/${this.type}/reason`], { state: { selectedItemIds } });
    }

    public toggleSelectItem(id: number): void {
        if (this.selectedItems.has(id)) {
            this.selectedItems.delete(id);
        } else {
            this.selectedItems.add(id);
        }
    }

    public selectAllItems(): void {
        this.orderItems?.forEach((item) => {
            this.selectedItems.add(item?.id!);
        });
    }

    public deSelectAllItems(): void {
        this.selectedItems.clear();
    }

    public toggleSelectAll(event: MatCheckboxChange): void {
        if (event.checked) {
            this.selectAllItems();
        } else {
            this.deSelectAllItems();
        }
    }

    public isAllSelected(): boolean {
        return this.orderItems!.length > 0 && this.orderItems!.every((item) => this.selectedItems.has(item?.id!));
    }

    public isSomeSelected(): boolean {
        return this.selectedItems.size > 0;
    }

    public onSelectAllButtonClick(): void {
        const event = {
            checked: !this.isAllSelected(),
        } as MatCheckboxChange;

        this.toggleSelectAll(event);
    }

    public getTranslationAsync(key: string, params?: object): Observable<string> {
        return this.translate.get(key, params);
    }
}
